import React from "react";
import { Link } from "react-router-dom";
import Stars from "@/components/Stars";

export default function ProductCard({ product }) {
  const off =
    product.mrp && product.mrp > product.price
      ? Math.round(((product.mrp - product.price) / product.mrp) * 100)
      : 0;
  return (
    <Link
      to={`/products/${product.id}`}
      className="card-hover block bg-white rounded-lg border border-[#E2E8E5] overflow-hidden group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square overflow-hidden bg-[#F9F9F7]">
        <img
          src={product.images?.[0] || "https://images.unsplash.com/photo-1561715276-a2d087060f1d"}
          alt={product.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#14A085] mb-1">
          {product.category}
        </div>
        <div className="text-sm font-medium text-[#0F3D2E] line-clamp-2 min-h-[2.5rem]">
          {product.title}
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-lg font-semibold text-[#0F3D2E]">₹{product.price}</span>
          {off > 0 && (
            <>
              <span className="text-xs text-[#6E877C] line-through">₹{product.mrp}</span>
              <span className="text-xs text-[#14A085] font-medium">{off}% off</span>
            </>
          )}
        </div>
        {product.vendor_name && (
          <div className="mt-1 text-xs text-[#6E877C] truncate">by {product.vendor_name}</div>
        )}
        <div className="mt-2">
          <Stars value={product.avg_rating || 0} count={product.review_count || 0} showCount />
        </div>
      </div>
    </Link>
  );
}
